/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lift': {
    width: 16,
    height: 16,
    viewBox: '0 0 17.22 16.85',
    data: '<g data-name="图层 2"><g data-name="图层 1"><rect pid="0" x="2.66" y="2.33" width="11.67" height="12.89" rx="2.05" ry="2.05" _fill="#74777a"/><path pid="1" _fill="none" _stroke="#c4c4c4" stroke-linecap="round" stroke-linejoin="round" d="M.5.5v15.85M16.72.5v15.85"/><path pid="2" _fill="none" _stroke="#c4c4c4" stroke-linejoin="round" d="M8.5 2.33v12.89"/></g></g>'
  }
})
